import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { VendorAchActions } from "../../actions/vendor-ach.actions";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";
import { VendorState } from "../../models/vendor-state";
import { AppState } from "../../reducers";
import { VendorSelectors } from "../../selectors/vendor.selectors";

@Injectable()
export class VendorAccountGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.account.get),
			withLatestFrom(this.store.select(VendorSelectors.account)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(VendorActions.account.getSuccess(state))
					: of(VendorActions.account.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(
				VendorActions.account.getApi,
				VendorActions.account.updateSuccess,
				VendorAdminActions.ach.added,
				VendorAchActions.namedChanged,
				VendorAdminActions.ach.removeSuccess,
				VendorAdminActions.ach.updateSuccess,
				VendorActions.beneficiary.createSuccess
			),
			switchMap(() =>
				this.vendorService.account().pipe(
					map((vendorState: VendorState) => {
						vendorState.loading = false;
						return VendorActions.account.getSuccess(vendorState);
					}),
					catchError((error) => of(VendorActions.account.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private vendorService: VendorService
	) {}

	private canUseStoreValue(state: VendorState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
